import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import { AppBar, Box, styled, Toolbar } from '@mui/material';
import { PostAsync } from 'common/httpRequests';
import { IconButtonAnimate } from 'components/animate';
import Logo from 'components/Logo';
import { HEADER, NAVBAR } from 'config';
import { BACKEND } from 'constants/settings';
import useOffSetTop from 'hooks/useOffSetTop';
import useResponsive from 'hooks/useResponsive';
import cssStyles from 'utils/cssStyles';
import LanguagePopover from './LanguagePopover';

type RootStyleProps = {
  isCollapse: boolean;
  isOffset: boolean;
  verticalLayout: boolean;
};

interface CustomerHeaderProps {
  onOpenSidebar?: () => void;
  isCollapse?: boolean | undefined;
  verticalLayout?: boolean;
}

export default function CustomerHeader({
  onOpenSidebar,
  isCollapse = false,
  verticalLayout = false,
}: CustomerHeaderProps) {
  const isOffset = useOffSetTop(HEADER.DASHBOARD_DESKTOP_HEIGHT) && !verticalLayout;

  const isDesktop = useResponsive('up', 'lg');

  function handleLogout() {
    const customerId = localStorage.getItem('customerId');
    PostAsync(`${BACKEND}/api/customerservice/Customer/logout/${customerId}`, {});
  }

  return (
    <RootStyle isCollapse={isCollapse} isOffset={isOffset} verticalLayout={verticalLayout}>
      <Toolbar
        sx={{
          minHeight: '100% !important',
          px: { lg: 5 },
          justifyContent: 'flex-end',
        }}
      >
        {isDesktop && verticalLayout && <Logo sx={{ mr: 2.5 }} />}

        {!isDesktop && (
          <IconButtonAnimate onClick={onOpenSidebar} sx={{ mr: 1, color: 'text.primary' }}>
            <MenuOpenIcon />
          </IconButtonAnimate>
        )}

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
          }}
        >
          <LanguagePopover />
        </Box>
      </Toolbar>
    </RootStyle>
  );
}

const RootStyle = styled(AppBar, {
  shouldForwardProp: (prop) =>
    prop !== 'isCollapse' && prop !== 'isOffset' && prop !== 'verticalLayout',
})<RootStyleProps>(({ isCollapse, isOffset, verticalLayout, theme }) => ({
  ...cssStyles(theme).bgBlur(),
  boxShadow: 'none',
  height: HEADER.MOBILE_HEIGHT,
  zIndex: theme.zIndex.appBar + 1,
  transition: theme.transitions.create(['width', 'height'], {
    duration: theme.transitions.duration.shorter,
  }),
  [theme.breakpoints.up('lg')]: {
    height: HEADER.DASHBOARD_DESKTOP_HEIGHT,
    width: `calc(100% - ${NAVBAR.DASHBOARD_WIDTH + 1}px)`,
    ...(isCollapse && {
      width: `calc(100% - ${NAVBAR.DASHBOARD_COLLAPSE_WIDTH}px)`,
    }),
    ...(isOffset && {
      height: HEADER.DASHBOARD_DESKTOP_OFFSET_HEIGHT,
    }),
    ...(verticalLayout && {
      width: '100%',
      height: HEADER.DASHBOARD_DESKTOP_OFFSET_HEIGHT,
      backgroundColor: theme.palette.background.default,
    }),
  },
}));
